// extracted by mini-css-extract-plugin
export var card = "_oe-0";
export var content = "_oe-2";
export var details = "_oe-3";
export var icon = "_oe-1";
export var iconBlue = "_oe-5";
export var iconBrand = "_oe-4";
export var iconGrayBlue = "_oe-6";
export var iconGreen = "_oe-7";
export var iconIndigo = "_oe-8";
export var iconOrange = "_oe-9";
export var iconPurple = "_oe-a";
export var iconRed = "_oe-b";
export var iconWarning = "_oe-c";